import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Unstable_Grid2";

import DoneSearchDoctors from "../components/DoneSearchDoctors";
import DoneTableDoctors from "../components/DoneTableDoctors";

const OrdersDoneDoctors = (props) => {
  const [done, setDone] = useState([]);
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const [labNames, setlabNames] = useState([]);

  //getting the data from search component
  const getOrderData = (data, count, labNames) => {
    setDone(data);
    setPageCount(count);
    setlabNames(labNames);
  };

  //getting the data from the pagination
  const getPage = (data) => {
    setPage(data);
  };

  return (
    <React.Fragment>
      <Grid container spacing={4} justifyContent={"center"}>
        <Grid md={12}>
          <DoneSearchDoctors
            getOrderData={getOrderData}
            page={page}
            rowCount={15}
          />
        </Grid>
        <Grid md={12}>
          <DoneTableDoctors
            data={done}
            getPage={getPage}
            pageCount={pageCount}
            labNames={labNames}
          />
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default OrdersDoneDoctors;
